import { useQuery } from "react-query";
import { getCarrierNameList } from "../../../../actions/CarrierAgreementMgmt/Carrier";

export const useGetCarrierNameList = () => {
  return useQuery("GetCarrierNameList", getCarrierNameList, {
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
};
